import { Box, Dialog, Paper, Typography } from "@mui/material";
import { Button } from "@covertree/ui";

interface SequoiaInvalidAddressModalProps {
  open: boolean;
  onClose: () => void;
}

export function SequoiaInvalidAddressModal({
  open,
  onClose,
}: SequoiaInvalidAddressModalProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Paper sx={{ mx: 5, my: 3, boxShadow: "none" }}>
        <img
          src={"/images/icons/cross.webp"}
          alt="cross"
          width="80px"
          height="80px"
        />
        <Typography variant="h4">Invalid address</Typography>

        <Typography variant="h6" color={"info.main"}>
          You have chosen an address in a different zip code, which is not
          allowed in the Sequoia flow.
        </Typography>

        <Typography variant="h6" color={"info.main"}>
          If you are certain about this address change for this policy, then
          this Sequoia quote should be discarded, and a new quote should be
          started.
        </Typography>

        <Box display="flex" mt={4}>
          <Button
            type="submit"
            onClick={onClose}
            data-testid="sequoia-invalid-address-close">
            Close
          </Button>
        </Box>
      </Paper>
    </Dialog>
  );
}
